module.exports = __webpack_public_path__ + "1021f4de6d183d7b26b98c493bce178d.ttf";